<template>
  <div class="remove_table_shadow">

    <div class="row" v-if="type == 'Portal-board'">
      <div class="col-sm-12 col-md-12 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="certificateIssue"
          >
            {{ $t("certificate_issue") }}
          </button>
        </div>
      </div>
    </div>

<!--    <app-table-->
<!--      :id="tableId"-->
<!--      :options="options"-->
<!--      @action="getListAction"-->
<!--    />-->
<!--Creating Parallel tabs for forms and form related actions. -->

    <div class="col-12">
      <div class="vertical-tab">
        <div class="row">
          <div class="col-md-3 pr-md-3 tab-menu">
            <div class="card card-with-shadow border-0">
              <div class="header-icon">

                <div class="icon-position d-flex justify-content-center">
                  <h5 style="margin-right: 10px;">Assigned Forms</h5>
                  <div class="tab-icon d-flex justify-content-center align-items-center">
                    <app-icon name="link" />
                  </div>
                </div>
              </div>
              <div class="px-primary py-primary vertical-tab-wrap">
                <div
                    class="nav flex-column nav-pills" role="tablist" aria-orientation="vertical">

                  <p class="text-center" v-if="taskFormsData.data && taskFormsData.data.length === 0">
                    No Forms Assigned Yet.
                  </p>
                  <app-overlay-loader v-if="preloader" />
                  <div v-for="(form, index) in taskFormsData.data" :key="index">
                    <a style="border-bottom: 0px; border-color: transparent;cursor: pointer; "
                        class="text-capitalize tab-item-link d-flex justify-content-between my-2 my-sm-3"
                        :class="getActiveClass(form.id)"
                        data-toggle="pill"
                        @click.prevent="selectForm(form)">
                      <span>{{ form.form.name ? form.form.name : '(Empty)' }} <i v-if="formId === form.id" class="fa fa-check-circle text-success"></i></span>
                      <span v-if="formId === form.id" class="active-icon"><app-icon name="chevron-right"/></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-9 pl-md-3">
            <TaskFormDetail v-if="formSelected" :id="formId"/>
            <h6 v-else class="mt-5">Please select the assigned form in the left area.</h6>
          </div>
        </div>
      </div>
    </div>
    
    
    <task-forms-view-modal
      v-if="isFormModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :id="formId"
      @close-modal="closeFormModal"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary";
import * as actions from "../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";
import { axiosGet, axiosPost } from "../../../../../Helpers/AxiosHelper.js";
import {COMPANY_JOB_SHOW} from "../../../../../Config/ApiUrl";
import {mapState} from "vuex";

export default {
  extends: CoreLibrary,
  name: "TaskFormIndex",
  props: {
    taskId: [Number, String],
  },
  data() {
    return {
      formSelected: false,
      type: '',
      preloader: false,
      formId:0,
      packages: {},
      taskFormsData: {},
      isFormModalActive: false,
      selectedUrl: "",
      tableId: "advance-table",
      options: {
        name: "AdvanceTable",
        url: actions.TASK_ASSIGN_FORMS,
        showHeader: true,
        columns: [
          {
            title: this.$t("name"),
            type: "custom-html",
            key: "form",
            modifier: (value, row) => {
              return `<a href="#" id="${row.id}" @click=${this.myFunction(row)}>${this.$t(value.name)}</a>`;
            },
          },
          {
            title: this.$t("description"),
            type: "custom-html",
            key: "form",
            modifier: (value) => {
              return `<span>${this.$t(value.description ?? '---')}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "pivot",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";
              let val = "Un Read";

              if (value.status === 2) {
                ClassName = `primary`;
                val = "Submited";
              } else if (value.status === 1) {
                ClassName = `dark`;
                val = "Pending";
              } else if (value.status === 3) {
                ClassName = `warning`;
                val = "Action Required";
              }
              else if (value.status === 4) {
                ClassName = `success`;
                val = "Approved";
              }

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                val
              )}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
          // {
          //   title: this.$t("status"),
          //   icon: "eye",
          //   type: "none",
          //   component: "app-add-modal",
          //   modalId: "demo-add-edit-Modal",
          // },
        ],
        // filters: [
        //   {
        //       "title": this.$t('date'),
        //       "type": "range-picker",
        //       "key": "date",
        //       "option": ["today", "thisMonth", "last7Days", "nextYear"]
        //   },
        //   {
        //       "title": this.$t('age'),
        //       "type": "range-filter",
        //       "key": "age-range",
        //       "maxTitle": this.$t('max_age'),
        //       "minTitle": this.$t('min_age'),
        //       "sign": ""
        //   },
        //   {
        //       "title": this.$t('status'),
        //       "type": "checkbox",
        //       "key": "status",
        //       "option": [
        //           {id: 'active', value: 'Active'},
        //           {id: 'inactive', value: 'Inactive'},
        //           {id: 'invited', value: 'Invited'},
        //       ],
        //   },
        //   {
        //       "title": this.$t('gender'),
        //       "type": "radio",
        //       "key": "filter-with-gender",
        //       "option": [
        //           {id: 'male', value: 'Male'},
        //           {id: 'female', value: 'Female'},
        //           {id: 'other', value: 'Other'},
        //       ],
        //       "header": {
        //           "title": this.$t('want_to_filter_your_list'),
        //           "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
        //       },
        //   },
        //   {
        //       "title": this.$t('search_and_select'),
        //       "type": "drop-down-filter",
        //       "key": "search select",
        //       "option": [],
        //   }
        // ],
        showFilter: false,
        showSearch: false,
        showCount: true,
        showClearFilter: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      
      },
    };
  },
  created() {
    // this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    getActiveClass(id){
      let string = '';
      string = this.formId === id?'active':'';
      return string
    },
    selectForm(form){
      this.formSelected = true
      this.formId = form.id;
      this.$store.commit('updateSharedData', {index: "taskFormData", newValue: form})
      this.$store.commit('updateSharedData', {index: "taskFormRevisionId", newValue: form.id})
      this.$hub.$emit('formRevisionIdChanged',  { formRevisionId: form.id })
    },
    getTaskForms (){
      this.preloader = true;
      axiosGet(actions.TASK_ASSIGN_FORMS +'/'+this.taskId)
          .then((res) => {
            let jsonString = JSON.stringify(res.data)
            this.$store.commit('updateSharedData', {index: "taskForms", newValue: jsonString})
            this.taskFormsData = res.data

            // let id = this.job.sites[0].id;

          })
          .catch((error) => {

          })
          .finally(() => {
            this.preloader = false;

          });
    },
    certificateIssue() {
      this.message = 'Testing Message';
      this.certificatedata.certificate_id = this.$attrs['props'].certificate_id;
      this.certificatedata.company_id = this.$attrs['props'].company_id;
      this.deleteConfirmationModalActive = true;
      },
    openFormModal() {
        this.isFormModalActive = true;
    },
    closeFormModal() {
      $("#form-view-Modal").modal("hide");
      this.isFormModalActive = false;
    //   this.searchAndSelectFilterOptions();
    },
    getListAction(rowData, actionObj, active) {

      this.rowData = rowData;

      if (actionObj.title == this.$t("view")) {
        //   alert(rowData.id);
           this.view(rowData);
            // this.openFormModal();
      }
    },
    view(rowData) {
            this.formId = rowData.form.id;
            let form_id = rowData.form_id;
            let form_revision_id = rowData.id;
            let form_body_id = rowData.form_body_id
            this.$emit('id',form_body_id, form_id, form_revision_id);
        },
    myFunction(data){
            let doc = document.getElementById(data.id);
            if(doc){
                doc.addEventListener('click', () => {
                this.view(data);
            }); 
            }
        },
    
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.name,
            value: name.name,
          };
        });
      });
    },
  },
  mounted() {
    this.getTaskForms();
    // let id = this.$attrs['props'];
    // let myLocation = location.href;
    // let split = myLocation.split("/");
    // let id = split[6].split("?")[0];
    // this.options.url = this.options.url + '/' + id.id;
    this.options.url = this.options.url + '/' + this.taskId;
    let myLocation = location.href;
    let split = myLocation.split("/");
    this.type = split[3].split("?")[0];

  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
<style scoped>
.remove_table_shadow .h-100 .datatable .table-responsive {
  box-shadow: none !important;
}
</style>
